import { createSlice } from '@reduxjs/toolkit';
import { generateReduxKeys } from '../../utils';
import { ROLES } from '../../constants';

const USER_ROLES = {
  0: ROLES.SUPERADMIN,
  1: ROLES.ADMIN,
  2: ROLES.MANAGER,
  3: ROLES.STAFF,
};

const initialState = generateReduxKeys({
  token: null,
  user: {},
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      localStorage.setItem(`token`, JSON.stringify(action.payload));
      state.token = action.payload;
    },
    setUser: (state, action) => {
      const userData = action.payload;
      const user = {
        ...userData,
        name: `${userData.first_name} ${userData.last_name ?? ''}`,
        role: USER_ROLES[userData.role] || 'unknown',
        roleValue: userData.role,
      };
      localStorage.setItem('user', JSON.stringify(user));
      state.user = user;
    },
  },
});

export const { setAuth, setUser } = authSlice.actions;

export default authSlice.reducer;
